import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { APP_CONFIG } from "../../app-config";
import SidebarHeader from "../../components/SidebarHeader";
import toast, { Toaster } from 'react-hot-toast';
import { apiCall } from "../../utils/api";
import { FaMoneyBillWave, FaStore, FaExchangeAlt } from 'react-icons/fa';
import { FiArrowLeft } from "react-icons/fi";

const COLORS = APP_CONFIG.colors;

function AgentDashboard() {
    const navigate = useNavigate();

    const menuItems = [
        {
            id: 1,
            name: "Commission",
            icon: <FaMoneyBillWave size={28} />,
            path: "/agent/commission",
        },
        {
            id: 2,
            name: "Retailer",
            icon: <FaStore size={28} />,
            path: "/agent/retailer",
        }
    ];


    return (
        <SidebarHeader>
            <div className="flex items-center gap-3 pb-4">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-200 hover:bg-gray-300 transition"
                >
                    <FiArrowLeft className="text-xl" />
                </button>
                <h1 className="text-lg font-semibold text-gray-800">
                    Agent - Dashboard
                </h1>
            </div>
            <div className="max-w-7xl mx-auto mb-16">
                <div className="grid grid-cols-2 gap-4 max-w-md ">
                    {menuItems.map((item) => (
                        <div
                            key={item.id}
                            onClick={() => navigate(item.path)}
                            className="flex flex-col tems-center justify-center p-4 rounded-xl cursor-pointer transition-all hover:bg-opacity-10"
                            style={{
                                background: COLORS.surfaceColor || '#ffffff',
                                border: `1px solid ${COLORS.borderColor}`,
                                color: COLORS.primaryColor
                            }}
                        >
                            <div className="flex items-center justify-center">
                                {item.icon}
                            </div>
                            <span className="text-xs font-medium mt-2 text-center" style={{ color: COLORS.textPrimary }}>
                                {item.name}
                            </span>
                        </div>
                    ))}
                </div>
            </div>

            <Toaster />
        </SidebarHeader>
    );
}

export default AgentDashboard;
